export function extractNumericShopifyId(shopifyGid: string): number | null {
  if (shopifyGid) {
    const match = shopifyGid.match(/\d+$/)
    return match && parseInt(match[0], 10)
  }
  return null
}
